import React from 'react';

import { Box, BoxProps, Flex } from '@withjoy/joykit';
import { SkeletonText, SkeletonThumbnail } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';

const ProductTileMetadata: React.FC<BoxProps> = ({ children, ...rest }) => {
  return (
    <Flex flexDirection="column" rowGap={1} marginTop={4} {...rest}>
      {children}
    </Flex>
  );
};

export const SearchResultTile = {
  Skeleton: () => {
    return (
      <Box>
        <SkeletonThumbnail width={'100%'} height={'unset'} paddingTop="100%" />
        <ProductTileMetadata marginTop={5} rowGap={3}>
          <SkeletonText rows={2} spacing={3} skeletonHeight={[pxToRem(16), null, null, pxToRem(18)]} />
          <SkeletonText rows={1} skeletonHeight={pxToRem(14)} width={9} />
          <SkeletonText rows={1} skeletonHeight={pxToRem(14)} width={pxToRem(80)} />
        </ProductTileMetadata>
      </Box>
    );
  }
};
